import React, { useState } from 'react';
import { AnchoredAlert, Tag } from '@amzn/storm-ui';
import { externalLink } from '@amzn/storm-ui-icons';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import {
  AlertContentContainer,
  LinkContainer,
  TooltipLink,
  TooltipWrapper,
  TooltipIcon,
} from './styles';
import { useDismissibleComponent } from '@amzn/storm-ui-utils';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const TOOLTIP_ID = 'aac-global-account-tooltip';

const GlobalAccountTooltipAlert = () => {
  const [isDismissed, dismiss] = useDismissibleComponent(TOOLTIP_ID);
  const [isManuallyOpened, setIsManuallyOpened] = useState(false);
  const isOpen = isManuallyOpened || !isDismissed;
  const bundle = useAccountDropdownBundle();
  const tooltipText = bundle.getMessage(
    'account-switcher-list-headings-single-global-account-tooltip-text',
  );
  const tooltipLinkText = bundle.getMessage(
    'account-switcher-list-headings-single-global-account-tooltip-link',
  );
  const learnMoreUrl = '/help';

  const handleClose = () => {
    dismiss();
    setIsManuallyOpened(false);
  };

  const handleClick = () => {
    setIsManuallyOpened(true);
  };
  return (
    <TooltipWrapper>
      <AnchoredAlert
        id={TOOLTIP_ID}
        position="bottom"
        isOpen={isOpen}
        onCloseButtonClick={handleClose}
        onClick={handleClick}
        variant="spotlight"
        trigger={<Tag variant="info" label="New" withIcon={true} />}
        {...getTaktAttributes(
          'global-account-tooltip',
          chromeComponents.HEADER,
        )}
      >
        <AlertContentContainer>
          {tooltipText}
          <LinkContainer>
            <TooltipLink
              href={learnMoreUrl}
              target="_blank"
              {...getTaktAttributes(
                'global-account-tooltip-link',
                chromeComponents.HEADER,
              )}
            >
              {tooltipLinkText}
            </TooltipLink>
            <TooltipIcon type={externalLink} size="small" />
          </LinkContainer>
        </AlertContentContainer>
      </AnchoredAlert>
    </TooltipWrapper>
  );
};

export default GlobalAccountTooltipAlert;
